
import { Vue, Component, Prop } from "vue-property-decorator";
import { current } from "@/contants/current";
import WxPay from "@/views/Components/pay.vue";

@Component({ components: { WxPay } })
export default class orderStatus extends Vue {
  private falgs: any = {
    isPay: false,
    showPopup: false,
  };
  private current: any = {};
  private onLineList: any[] = []; // 线上支付列表
  private underLineList: any[] = []; // 线下支付列表
  private selectPayType: any = {}; // 选中的支付方式
  private money_desc: string = ""; //费用说明
  private orderid: string = ""; //订单号
  private payBtnMsg = "确认支付";
  private wxData: any = {};
  private timer: any; //倒计时
  private payStatus: string = "待支付";
  private payCode: any = {};
  private payShow: any = false;

  @Prop({
    type: Object,
    default: {},
    required: true,
  })
  datas!: any;
  created() {
    this.current = new current();
    console.log(this.datas, "订单");

    if (this.datas.createtime.indexOf("月") === -1) {
      let { year, month, day } = this.current.changeFormDate(this.datas.createtime);
      this.datas.createtime = year + "年" + month + "月" + day + "日";
    }

    this.InitPayConfig();
  }
  /**
   * @title 初始化支付接口
   * @date 2020-01-16
   */
  async InitPayConfig() {
    let params = {
      m: this.datas.ssl_m,
      muid: this.datas.ssl_muid,
    };
    let res = await this.$http.Pay.InitPayConfig(params);

    if (res.Code === 1000) {
      this.selectPayType = res.PayEntitys[0];
      this.money_desc = res.signUp_Set.money_desc;
      //this.Orderid = res.Orderid;
      this.falgs.isPay = true;

      for (var i in res.PayEntitys) {
        if (res.PayEntitys[i].paycode) {
          // 线上支付列表
          this.onLineList.push(res.PayEntitys[i]);
        } else {
          // 线下支付列表
          this.underLineList.push(res.PayEntitys[i]);
        }
      }
    } else if (res.Code === 6008) {
      this.payStatus = "已支付";
    }
  }
  /**
   * 支付
   */
  async handlePay() {
    var _that = this
    if (this.falgs.isPay) {
      let { paytype, paycode } = this.selectPayType;
      if (paytype >= 4 ){
        this.$emit('sendPaytype', paytype)
      }else{
        this.falgs.isPay = false;
        this.payBtnMsg = "请稍后...";
        let { paytype, paycode } = this.selectPayType;
        let IsMobile = this.current.is_Mobile();
        let IsWxClient = this.current.isWeiXin();
        let params = {
          m: this.datas.ssl_m,
          muid: this.datas.ssl_muid,
          Orderid: '',
          PayType: paytype,
          PayCode: paycode,
          IsMobile,
          IsWxClient,
        }

        let res = await this.$http.Pay.CreatePayOrder(params);

        if (res.Code === 1000) {
          console.log(this.selectPayType)
          if (this.selectPayType.paytype === 1) {
            if ( this.selectPayType.IsPayRed ){
              window.location.href = res.callback_url
            }else{
              this.payShow = true
              this.payCode = 'data:image/gif;base64,' + res.code_url
              this.orderid = res.orderid
              _that.timer = setInterval(() => {
                _that.QueryOrder()
              }, 1000)
            }
          }else if (this.selectPayType.paytype === 3) {
            this.orderid = res.orderid;
            //微信支付
            this.wxData = {
              orderid: res.orderid,
              paymoney: this.datas.paymoney,
              code_url: res.code_url,
            };
            this.falgs.showPopup = true;

            this.timer = setInterval(() => {
              this.QueryOrder();
            }, 1000);
          }
        }

        this.falgs.isPay = true;
        this.payBtnMsg = "支付";
      }
    }
  }
  /**
   * 查询订单是否支付状态
   */

  async QueryOrder() {
    try {
      let m = this.datas.ssl_m;
      let params = {
        m,
        orderid: this.orderid,
      };
      let _Res = await this.$http.Pay.QueryOrder(params);

      if (_Res.Code === 1000) {
        clearInterval(this.timer);
        this.falgs.showPopup = false;
        this.$message({ message: "支付成功", type: "success", duration: 6000 });
        this.InitPayConfig();
      }
    } catch (err) {
      console.log(err);
    }
  }
  /**
   * @title 选择支付方式
   */
  handleChoosePayType(item: any) {
    this.selectPayType = item;
  }
  closePay(){
    this.payShow = false
    this.payBtnMsg = '确认支付'
  }
}
